<template>
	<div :class="`form-group form-group-${name}`">
		<!-- input -->
		<template v-if="field === 'input'">
			<input
				:name="name"
				:placeholder="placeholder"
				:data-label="label"
				:required="required"
				:type="type"
				:disabled="disabled"
				class="form-control ooef-field input disabled"
				:aria-required="required">
		</template>

		<!-- select -->
		<template v-else-if="field === 'select'">
			<multiselect
				:options="options"
				:searchable="optionConfig.searchable"
				:close-on-select="optionConfig.close_on_select"
				:show-labels="optionConfig.show_labels"
				:track-by="optionConfig.trackby"
				:label="optionConfig.name"
				:placeholder="placeholder"
				:disabled="disabled"
				:internal-search="optionConfig.internal_search"
				:clear-on-select="optionConfig.clear_on_select"
				:preselect-first="optionConfig.preselect_first">
			</multiselect>
		</template>

		<!-- textarea -->
		<template v-else-if="field === 'textarea'">
			<textarea
				:name="name"
				:placeholder="placeholder"
				:data-label="label"
				:required="required"
				:disabled="disabled"
				:type="type"
				class="form-control ooef-field textarea disabled"
				rows="4"
				:aria-required="required"/>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			required: false,
		},
		name: {
			type: String,
			default: '',
		},
		field: {
			type: String,
			default: 'input', // input , select, textarea
		},
		type: {
			type: String,
			default: 'text', // text, email, number
		},
		options: {
			type: Array,
			default: () => [],
		},
		optionConfig: {
			type: Object,
			default: null,
		},
		label: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isLoading: false,
			isInputError: false,
		};
	},
	computed: {},
	watch: {},
	methods: {},
};
</script>

<style>

</style>
